// @flow
import * as React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col, Button, Form, FormGroup } from 'react-bootstrap';
import { Field, reduxForm, getFormValues } from 'redux-form';
import Input from '../../components/Input';
import { getPublicSetting } from '../../actions/settings/settingsCreators';
import type { Dispatch } from 'redux';

import {
  validateRequired,
  validateMobilePhoneNumber,
  validateEmail,
  validatePasswordsMatch,
  validateTermsConditions
} from '../../helpers';

type Props = {
  isSaving: boolean,
  showSubmit: boolean,
  disableFilled: boolean,
  successMsg: ?string,
  errorMsg: ?string,
  formValues: any,
  handleSubmit: Function,
  settings: Object,
  getPublicSetting: (s: string) => void
};

class UserRegistrationForm extends React.Component<Props> {
  componentDidMount() {
    const { getPublicSetting } = this.props;
    getPublicSetting('tcPdf');
  }

  render() {
    const {
      handleSubmit,
      formValues,
      disableFilled,
      settings,
      showSubmit,
      isSaving,
      errorMsg
    } = this.props;
    const password = formValues ? formValues.password : undefined;

    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <FormGroup>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="text"
                label="Name"
                name="name"
                validate={validateRequired}
                disabled={disableFilled}
              />
            </Col>
          </FormGroup>
        </Row>
        <Row>
          <FormGroup>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="email"
                name="email"
                label="Email"
                validate={[validateRequired, validateEmail]}
                disabled={disableFilled}
              />
            </Col>
          </FormGroup>
        </Row>
        <Row>
          <FormGroup>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="phone"
                name="phone"
                label="Mobile Phone"
                validate={[validateRequired, validateMobilePhoneNumber]}
              />
            </Col>
          </FormGroup>
        </Row>
        <Row>
          <FormGroup>
            <Col sm={12} className="form-input hide-form-label">
              <label htmlFor="password">Password</label>
              <sub className="subtext">
                Minimum of 8 characters. Must contain at least one number, one
                uppercase, and one lowercase letter.
              </sub>
              <Field
                component={Input}
                type="password"
                name="password"
                validate={validateRequired}
                id="password"
              />
            </Col>
          </FormGroup>
        </Row>
        <Row>
          <FormGroup>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="password"
                name="passwordConfirmation"
                label="Confirm Password"
                validate={val => validatePasswordsMatch(password, val)}
              />
            </Col>
          </FormGroup>
        </Row>
        <Row>
          <FormGroup>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="termsAndConditions"
                name="dateTcSigned"
                parse={val => (val ? moment().format() : false)}
                file={
                  settings && settings.tcPdf ? settings.tcPdf.value : undefined
                }
                validate={validateTermsConditions}
              />
            </Col>
          </FormGroup>
        </Row>

        <Row>
          <Col sm={12}>
            {showSubmit && (
              <Button
                bsStyle="primary"
                type="submit"
                className="relative-padding"
                disabled={isSaving}
              >
                {isSaving ? 'Submitting...' : 'Submit'}
              </Button>
            )}
          </Col>
        </Row>
        <br />
        {errorMsg && (
          <div>
            <div className="alert alert-danger">{errorMsg}</div>
            <br />
          </div>
        )}
      </Form>
    );
  }
}

// Decorate the form component
UserRegistrationForm = reduxForm({
  form: 'userRegistrationForm'
})(UserRegistrationForm);

const mapStateToProps = state => {
  return {
    formValues: getFormValues('userRegistrationForm')(state),
    settings: state.settings
  };
};

const mapDispatchToProps = (dispatch: Dispatch<*>) => {
  return bindActionCreators(
    {
      getPublicSetting
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserRegistrationForm);



// WEBPACK FOOTER //
// ./src/containers/users/UserRegistrationForm.js